import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const advanceTrainingFollowUpEndDateToHourQuota = createApiThunk<void, { trainingFollowUpId: string }>(
  "trainingFollowUps/advanceTrainingFollowUpEndDateToHourQuota",
  async ({ trainingFollowUpId }, { extra: { adminRepository } }) => {
    return adminRepository!.advanceTrainingFollowUpEndDateToHourQuota(trainingFollowUpId);
  },
);

export const resetAdvanceTrainingFollowUpEndDateToHourQuota = createAction("admin/resetAdvanceTrainingFollowUpEndDateToHourQuota");
